import IconCalendar from './component.jsx'
export default IconCalendar
